<template>
  <div class="empty-state">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseEmptyState'
}
</script>

<style lang="scss" scoped>
.empty-state {
  $color-primary: map-get($colors-util, 'light');
  $color-secondary: nth($colors-custom, 2);

  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 20px;
  text-align: center;
  color: $color-primary;

  svg {
    height: 40px;
    fill: $color-primary;
  }

  h3 {
    font: {
      weight: 700;
      size: 14px;
    }
    line-height: 120%;
  }

  p,
  a {
    font: {
      weight: 400;
      size: 12px;
    }
    line-height: 130%;
  }

  a {
    transition: all 0.1s;
    color: $color-secondary;
    font-weight: 500;

    &:hover {
      color: lighten($color-secondary, 10%);
    }
  }
}
</style>
